import React, { ComponentProps, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { Spinner } from '@vwfs-bronson/bronson-react';
import { loadingActions } from '../services/redux/features/loading.slice';

/**
 * - LocalSpinner prevents coinciding display of global loading spinner.
 */
export const LocalSpinner = (props: ComponentProps<typeof Spinner>) => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(loadingActions.setRenderingLocalSpinner(true));

    return () => {
      dispatch(loadingActions.setRenderingLocalSpinner(false));
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return <Spinner {...props} />;
};
